import React, { useContext, useEffect, useState } from 'react'
import { Context } from '../Context/Context'
import ConfirmConversion from '../Components/ConfirmConversion'
import ViewDetailsBar from '../Components/ViewDetailsBar';
import CreateAcctBar from '../Components/CreateAcctBar';
import CreateAcct from '../Components/CreateAcct';
import Overview from '../Components/Overview';
import warn from '../Components/Images/Warn.svg'
import close from '../Components/Images/close.png'

const Home = ({ NumberOfUserAcct, NumberOfInvoices, verified, UserProfile, NumberOfBeneficiaryAcct, UserAcctDetails }) => {

    const {
        acctBar,
        acctDetailsBar,
        sendBar,
        convertBar,
        liveRatesBar,
        sideBar,
        overViewTransactionDetails,
        method,
        beneficiaryAcct,
        beneficiaryAcctInCrypto,
        formDatas,
        cryptoformData,
        selectedCurrency
    } = useContext(Context)

    const [openSendBar, setOpenSendBar] = useState(false);
    const [SendErrorBar, setSendErrorBar] = useState({ state: false, message: '' });
    const [openAcctModal, setAcctModal] = useState(false);
    const [AcctErrorModal, setAcctErrorModal] = useState(false);

    useEffect(() => {
        if (acctBar || acctDetailsBar || sideBar || sendBar || convertBar || liveRatesBar || overViewTransactionDetails) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [acctBar, acctDetailsBar, sendBar, convertBar, sideBar, liveRatesBar, overViewTransactionDetails])

    useEffect(() => {
        if (openSendBar) {
            setTimeout(() => {
                setOpenSendBar(false)
            }, 4200);
        }
        if (SendErrorBar) {
            setTimeout(() => {
                setSendErrorBar({ state: false, message: '' })
            }, 5200);
        }
        if (AcctErrorModal) {
            setTimeout(() => {
                setAcctErrorModal(false)
            }, 5200);
        }
        if (openAcctModal) {
            setTimeout(() => {
                setAcctModal(false)
            }, 4200);
        }
    }, [openSendBar, SendErrorBar, AcctErrorModal, openAcctModal])

    return (
        <div>
            <div className={NumberOfUserAcct > 0 ? 'block' : 'hidden'}>
                <Overview setSendErrorBar={setSendErrorBar} setOpenSendBar={setOpenSendBar} NumberOfBeneficiaryAcct={NumberOfBeneficiaryAcct} NumberOfInvoices={NumberOfInvoices} UserProfile={UserProfile} UserAcctDetails={UserAcctDetails} NumberOfUserAcct={NumberOfUserAcct} />
                <ConfirmConversion />
                <ViewDetailsBar />

                {openSendBar && (
                    <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Money sent.</p>
                                {method === 'bank' ? (
                                    <p className='text-[14px] text-[#CFF9DE] font-normal'> <span className='font-medium'>${formDatas.amount}</span> is on it's way to <span className='font-medium'>{beneficiaryAcct?.full_name}</span></p>
                                ) : method === 'crypto' ? (
                                    <p className='text-[14px] text-[#CFF9DE] font-normal'> <span className='font-medium'>${cryptoformData.amount}</span> is on it's way to <span className='font-medium'>{beneficiaryAcctInCrypto?.full_name}</span></p>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <img
                                onClick={() => setOpenSendBar(false)}
                                className='size-[10px] cursor-pointer'
                                src={close}
                                alt=""
                            />
                        </div>
                    </div>
                )}

                {SendErrorBar.state && (
                    <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed!</p>
                                <p className='text-[14px] text-[#CFF9DE] font-normal'>Failed to send money to {beneficiaryAcct?.full_name}!.</p>
                            </div>
                            <img
                                onClick={() => setSendErrorBar({ state: false, message: '' })}
                                className='size-[10px] cursor-pointer'
                                src={close}
                                alt=""
                            />
                        </div>
                    </div>
                )}

            </div>
            <div className={NumberOfUserAcct === 0 ? 'block' : 'hidden'}>
                <CreateAcct verified={verified} NumberOfBeneficiaryAcct={NumberOfBeneficiaryAcct} NumberOfInvoices={NumberOfInvoices} UserProfile={UserProfile} NumberOfUserAcct={NumberOfUserAcct} />

                {openAcctModal && (
                    <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Account created.</p>
                                <p className='text-[14px] text-[#CFF9DE] font-normal'>You've Successfully Created your {selectedCurrency.value} Account </p>
                            </div>
                            <img
                                onClick={() => setAcctModal(false)}
                                className='size-[10px] cursor-pointer'
                                src={close}
                                alt=""
                            />
                        </div>
                    </div>
                )}
                {AcctErrorModal && (
                    <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to create account.</p>
                                <p className='text-[14px] text-[#CFF9DE] font-normal'>We couldn’t create your account at the moment. Please try again later.</p>
                            </div>
                            <img
                                onClick={() => setAcctErrorModal(false)}
                                className='size-[10px] cursor-pointer'
                                src={close}
                                alt=""
                            />
                        </div>
                    </div>
                )}
            </div>
            <CreateAcctBar verified={verified} setAcctErrorModal={setAcctErrorModal} AcctErrorModal={AcctErrorModal} openAcctModal={openAcctModal} setAcctModal={setAcctModal} />
        </div>
    )
}

export default Home